/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Toast from '../toast';
import * as transectionService from '../../../services/transectionService'
import { BASE_IMAGE_PATH } from '../../../configs/api';
class Credit extends Component {
   constructor(props) {
      super(props);
      this.state = {
         amount: null,
         remark: "",
         mpassword: "",
         toastMsg: "",
         toastType: "",
         loading: false
      };
   }
   showToast(msg, type) {
      let self = this
      this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
          setTimeout(() => {
              self.setState({ toastMsg: "", toastType: "", showToast: false })
          }, 3000);
      })
  }
  handleKey(e) {
   if (e.keyCode === 13) {
     this.submitData();
   }
   }
   async submitData() {
      if(this.state.loading){
         return false
      } else {
         this.setState({loading:true},async()=>{
            let data = {
               "creditRefAmount": parseFloat(this.state.amount),
               "username": this.props.user.username,
               "masterPassword": this.state.mpassword,
               "description": this.state.remark
            }
            await transectionService.creditRef(data).then((res) => {
               setTimeout(()=>{ this.setState({loading:false})},1000)
               if (res.isSuccess) {
                  this.props.notify("Credit Updated Successfully!" ,"success");
                  this.props.closeAndUpdate()
               } else {
                  this.props.notify(res.exception.message,"error");
               }
            })     
         })
      }
   }
   change(e) {
      const name = e.target.name;
      let value = e.target.value;
      this.setState({ [name]: value })
   }
   componentDidMount() {
   }
   render() {
      return (
         <>
            <div className="modal fade show" style={{ display: 'block' }} id="mywithdraw" role="dialog" aria-modal="true">
               <div className="modal-dialog modal-dialog-scrollable">
                  <div className="modal-content">
                     <div className="modal-header">
                        <h4 className="modal-title">Credit</h4>
                        <button type="button" className="close text-white" data-dismiss="modal" onClick={() => { this.props.closePopup() }}>×</button>
                     </div>
                     <div className="modal-body lst-pop ">
                  <div className="row m-b-20">
                     <div className="col-md-4">
                        <label className="deposite-user-first">Old Credit</label>
                     </div>
                     <div className="col-md-8">
                              <span className="popup-box wid-98" id="deposite-first">{!!this.props.user.creditRef ? this.props.user.creditRef : "0.00"}</span>
                     </div>
                  </div>
                  <div className="row m-b-20">
                           <div className="col-md-4">
                              <label>New Credit</label>
                           </div>
                           <div className="col-md-8">
                              <input type="number" autoFocus tabIndex={1} name="amount" onChange={(e) => { this.change(e) }} className="maxlength10" value={this.state.amount} />
                           </div>
                        </div>
                        <div className="row m-b-20">
                           <div className="col-md-4">
                              <label>Remarks</label>
                           </div>
                           <div className="col-md-8">
                              <textarea name="remark" tabIndex={2} id="deposit-remark" onChange={(e) => { this.change(e) }} value={this.state.remark}></textarea>
                           </div>
                        </div>
                        <div className="row m-b-20">
                           <div className="col-md-4">
                              <label>Master Password</label>
                           </div>
                           <div className="col-md-8">
                              <input type="Password" tabIndex={3} name="mpassword" id="mpassword" onKeyUp={(e)=>{this.handleKey(e)}} onChange={(e) => { this.change(e) }} required="" />
                           </div>
                        </div>
                        </div>
               <div className="modal-footer">
                        <a  onDoubleClickCapture={(e)=>{e.preventDefault();return false;}} onClick={() => { if(!this.state.loading) { this.submitData()} }} tabIndex={4} className="pop-edit-btn" style={{ cursor: "pointer" }}>Submit {this.state.loading && <img style={{height:"16px"}} alt="" src={ BASE_IMAGE_PATH + "/aimg/loader.gif"} />}</a>
                        &nbsp;&nbsp;
                        <a className="pop-edit-btn" tabIndex={5} onClick={() => { this.props.closePopup() }} data-dismiss="modal" style={{cursor: "pointer"}}>Cancel</a>                        
                     </div>
                     {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                  </div>
               </div>
               <div className="modal-backdrop fade show" onClick={() => { this.props.closePopup() }}></div>
               </div>            
         </>
      )
   }
}

function mapStateToProps(state) {
   return {
   };
}

function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(Credit);